import { fonts } from 'src/global/theme/fonts';

export enum FONTS_SIZES {
  XXXLARGE = '100px',
  XXLARGE = '40px',
  XLARGE = '25px',
  LARGE = '22px',
  SLARGE = '20px',
  XMEDIUM = '18px',
  MEDIUM = '16px',
  SMEDIUM = '15px',
  SSMALL = '14px',
  SMALL = '13px',
  XSMALL = '12px',
  XXSMALL = '10px',
  XXXSMALL = '8px'
}

export enum LINE_HEIGHTS {
  XXXLARGE = '70px',
  XXLARGE = '56px',
  XLARGE = '35px',
  LARGE = '30px',
  SLARGE = '28px',
  XMEDIUM = '25px',
  MEDIUM = '24px',
  SMEDIUM = '22px',
  SSMALL = '20px',
  SMALL = '19px',
  XSMALL = '17px',
  XXSMALL = '14px',
  XXXSMALL = '8.8px'
}

const variants = {
  'Body-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.SMEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Body-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.SMEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Balance-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XLARGE,
    lineHeight: LINE_HEIGHTS.XLARGE
  },
  'Caption-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.MEDIUM,
    lineHeight: LINE_HEIGHTS.MEDIUM
  },
  'Amount-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XXLARGE,
    lineHeight: LINE_HEIGHTS.XXLARGE
  },
  'Title-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.LARGE,
    lineHeight: LINE_HEIGHTS.XMEDIUM
  },
  'H1-Bold': {
    ...fonts.RHDBoldNormal,
    fontSize: FONTS_SIZES.LARGE,
    lineHeight: LINE_HEIGHTS.SLARGE
  },
  'QS-H1-Bold': {
    ...fonts.QSDBoldNormal,
    fontSize: FONTS_SIZES.XSMALL,
    lineHeight: LINE_HEIGHTS.XXSMALL
  },
  'H1-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.LARGE,
    lineHeight: LINE_HEIGHTS.LARGE
  },
  'H2-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.SLARGE,
    lineHeight: LINE_HEIGHTS.SLARGE
  },
  'H2-Bold': {
    ...fonts.RHDBoldNormal,
    fontSize: FONTS_SIZES.SLARGE,
    lineHeight: LINE_HEIGHTS.SLARGE
  },
  'H3-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XMEDIUM,
    lineHeight: LINE_HEIGHTS.XMEDIUM
  },
  'H3-Bold': {
    ...fonts.RHDBoldNormal,
    fontSize: FONTS_SIZES.XMEDIUM,
    lineHeight: LINE_HEIGHTS.XMEDIUM
  },
  'Callout-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.MEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Callout-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.MEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Callout-Bold': {
    ...fonts.RHDBoldNormal,
    fontSize: FONTS_SIZES.MEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Caption-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.SSMALL,
    lineHeight: LINE_HEIGHTS.SSMALL
  },
  'Caption-Small': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XSMALL,
    lineHeight: LINE_HEIGHTS.XSMALL
  },
  'Caption-XSmall': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XXSMALL,
    lineHeight: LINE_HEIGHTS.XXSMALL
  },
  'Caption-XSmall-Semi-Bold': {
    ...fonts.RHDMediumSemiBold,
    fontSize: FONTS_SIZES.XXSMALL,
    lineHeight: LINE_HEIGHTS.XXSMALL
  },
  'H4-Bold': {
    ...fonts.RHDBoldNormal,
    fontSize: FONTS_SIZES.MEDIUM,
    lineHeight: LINE_HEIGHTS.SMEDIUM
  },
  'Overline-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.XSMALL,
    lineHeight: LINE_HEIGHTS.XSMALL
  },
  'Overline-Medium': {
    ...fonts.RHDMediumNormal,
    fontSize: FONTS_SIZES.XSMALL,
    lineHeight: LINE_HEIGHTS.XSMALL
  },
  'Overline-Medium-Semi-Bold': {
    ...fonts.RHDMediumSemiBold,
    fontSize: FONTS_SIZES.XSMALL,
    lineHeight: LINE_HEIGHTS.XSMALL
  },
  'H3-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.XMEDIUM,
    lineHeight: LINE_HEIGHTS.XMEDIUM
  },
  'Small-Title-Regular': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.SMALL,
    lineHeight: '19px',
  },
  'Error-Metrics': {
    ...fonts.RHDRegularNormal,
    fontSize: FONTS_SIZES.SLARGE,
    lineHeight: LINE_HEIGHTS.SSMALL
  },
};

export type VARIANTS = keyof typeof variants;
export const typographyStyleVariants = variants;

export default variants;
